import React, { useState, useEffect } from "react";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../assets/styles/TextEditor.css";

const TextEditor = ({
  getContent,
  setClearData,
  clearData,
  initialContent,
  onEditorEmptyChange,
}) => {
  const [editorState, setEditorState] = useState(() => {
    if (initialContent) {
      const blocksFromHTML = convertFromHTML(initialContent);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    } else {
      return EditorState.createEmpty();
    }
  });

  // const handleEditorChange = (state) => {
  //   setClearData(false);
  //   setEditorState(state);

  //   // Notify parent about editor state
  //   if (onEditorEmptyChange) {
  //     onEditorEmptyChange(isEditorEmpty());
  //   }
  // };

    const handleEditorChange = (state) => {
  setClearData(false);
  setEditorState(state);
  if (onEditorEmptyChange) {
    const contentState = state.getCurrentContent();
    const isEmpty = !contentState.hasText();
    onEditorEmptyChange(isEmpty);
  }
};

  const sendContent = () => {
    const contentHtml = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    const trimmedHtml = contentHtml.trim(); // Make sure contentHtml is a string before calling trim
    getContent(trimmedHtml);
  };

  useEffect(() => {
    sendContent();
  }, [editorState]);

  useEffect(() => {
    if (clearData === true) {
      setEditorState(() => EditorState.createEmpty());
    }
  }, [clearData]);

  useEffect(() => {
    if (initialContent !== undefined && initialContent !== null) {
      const blocksFromHTML = convertFromHTML(initialContent);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [initialContent]);

  const isEditorEmpty = () => {
    const contentState = editorState.getCurrentContent();
    const hasText = contentState.hasText();
    return !hasText;
  };

  return (
    <div>
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        editorStyle={{
          border: "1px solid",
          height: "20rem",
          width: "100%",
          margin: 0,
        }}
      />
    </div>
  );
};

export default TextEditor;
